import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Apps gringas complicadas',
    desc: 'Ignoran las remesas y la brecha salarial (wage gap) latina.'
  }, {
    title: 'Plantillas genéricas',
    desc: 'No tienen fórmulas automáticas para salir de deudas (método snowball).'
  }, {
    title: 'Videos de YouTube',
    desc: 'Mucha motivación, pero sin un archivo Excel listo para copiar y usar.'
  }, {
    title: 'Excel desde cero',
    desc: 'Toma horas configurarlo, tiempo que no tienes cuando cuidas a tus hijos.'
  }, {
    title: 'Grupos de Facebook',
    desc: 'Dan buenos consejos, pero no te entregan archivos editables que funcionen.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-16">
            Por qué lo que probaste no funcionó
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-17">
            No es tu culpa. Has estado usando las herramientas equivocadas.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-cream transition-colors" data-id="element-19">
              <XCircleIcon className="w-6 h-6 text-danger flex-shrink-0 mt-1" data-id="element-20" />
              <div data-id="element-21">
                <h3 className="font-bold text-lg text-charcoal" data-id="element-22">
                  {item.title}
                </h3>
                <p className="text-charcoal/80" data-id="element-23">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}